import { render, staticRenderFns } from "./yarn.vue?vue&type=template&id=3d85ada4&scoped=true"
import script from "./yarn.vue?vue&type=script&lang=js"
export * from "./yarn.vue?vue&type=script&lang=js"
import style0 from "./yarn.vue?vue&type=style&index=0&id=3d85ada4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d85ada4",
  null
  
)

export default component.exports